import { createSlice } from "@reduxjs/toolkit";

const paymentPendingCountSlice = createSlice({
    name: 'pendingCount',
    initialState: {
        depositCount: 0,
        withdrawCount: 0,
    },
    reducers: {
        depositCountHandler: (state,action) => {
            state.depositCount = action.payload
        },
        withdrawCountHandler: (state,action) => {
            state.withdrawCount = action.payload
        }
    }
});

export const {depositCountHandler,withdrawCountHandler} = paymentPendingCountSlice.actions;
export default paymentPendingCountSlice.reducer;